// LeaderboardUserCards.js
import { connect } from 'react-redux';

import LeaderboardUserCards from '../component/LeaderboardUserCards.jsx';
import getListData from '../selector/getListData.js';
import getMeData from '../selector/getMeData.js';
import fetchLeaderboardUsers from '../action/fetchLeaderboardUsers.js';
import { RANGE_24H } from '../resource/leaderboardConstants.js';
import { list as listSelectPath } from '../resource/selectPath.js';

const range = RANGE_24H;

const mapStateToProps = (state, { category, region }) => {
  const selectPath = listSelectPath.leaderboard({ region, category, range });
  const userIds = getListData(state, selectPath, 'itemIds');
  const isAuthed = getMeData(state, 'id') != null;

  return {
    userIds,
    category,
    isAuthed,
  };
};

const mapDispatchToProps = (dispatch, { category, region }) => {
  return {
    fetchLeaderboardUsers: () => {
      return dispatch(
        fetchLeaderboardUsers({
          category,
          region,
          range,
          limit: 40,
        })
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  // equals to `{ ...ownProps, ...stateProps, ...dispatchProps }`
  // ref: https://github.com/reduxjs/react-redux/blob/v7.1.0/src/connect/mergeProps.js
  null,
  { forwardRef: true }
)(LeaderboardUserCards);
